/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {ValidationError} from '../custom-validator.class';

// region Other Classes
type Errors = {[key: string]: any};
// endregion

let REGEX = /^[^\s@]+@[^\s@]+$/;

let EMPTY_ERRORS = {};

export function emailValidator(control: AbstractControl): Errors {
    return !REGEX.test(control.value) ? {email: new ValidationError('Invalid email address.')} : EMPTY_ERRORS;
}

@Directive({
    selector: '[emailValidation]',
    providers: [{provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true}]
})
export class EmailValidatorDirective implements Validator {

    private valFn = emailValidator;

    validate(control: AbstractControl): Errors {
        return this.valFn(control);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/email/email-validator.directive.ts